import { NamespacedStoreState } from '@Types/store.types';

export const getSelectedSensorIds = (state: NamespacedStoreState) =>
	state.entitlements.sensorGroup.sensorGroupById.paginatedSensorGroupPairs?.sensorGroupPairs.map(
		sensor => ({
			sensorId: sensor.sensorId,
			channelType: sensor.channelType,
			resolutions: sensor.resolutions,
		}),
	) || [];
